import { Status, StatusType } from '@app/components/various/Status';
import { Tooltip } from '@app/components/various/Tooltip';

interface Props {
  status: StatusType;
  tooltip: React.ReactNode;
}

export const StatusCell = ({ status, tooltip }: Props) => {
  return (
    <Tooltip content={tooltip}>
      <span className="z-interactiveTableItem m-auto">
        <Status type={status} />
      </span>
    </Tooltip>
  );
};
